<template>
  <div>
    <van-popup v-model="visible" position="bottom">
      <van-sticky>
        <van-nav-bar
          :title="obj.TblName"
          left-text="返回"
          left-arrow
          placeholder
          @click-left="cmdClose"
        />
      </van-sticky>

      <div class="main">
        <van-grid :border="false" :column-num="2" clickable>
          <!-- <van-grid-item icon="friends-o" :text="obj.CustTotal + '位'" />
          <van-grid-item icon="clock-o" :text="obj.minute + '分鐘'" /> -->
          <van-grid-item>
            <van-icon name="friends-o" size="40" />
            <div class="text-size">{{ obj.CustTotal }} 位</div>
          </van-grid-item>
          <van-grid-item>
            <van-icon name="clock-o" size="40" />
            <div class="text-size">{{ obj.minute }} 分鐘</div>
          </van-grid-item>
        </van-grid>
        <van-divider />
        <!-- <pre>{{ orderi }}</pre> -->
        <div style="text-align: left">
          <el-timeline>
            <el-timeline-item
              v-for="t in gGroupBy(orderi, 'OrderTime')"
              :key="t"
              :timestamp="t"
              placement="top"
            >
              <van-row
                v-for="oi in orderi.filter((r) => r.OrderTime == t)"
                :key="oi.rno"
                class="text-size"
              >
                <van-col span="17">
                  <span v-if="['S1', '-'].includes(oi.ItemType)" class="s1"
                    >{{ oi.ItemName }}
                  </span>
                  <span v-else class="s2">{{ oi.ItemName }} </span>
                  <van-tag v-if="oi.Remark" size="large"> {{ oi.Remark }}</van-tag>
                  <!-- {{ oi.ItemType }} -->
                </van-col>

                <!-- <van-col span="17">
                  <span v-if="oi.ItemType == 'S2'" class="s2">{{ oi.ItemName }}</span>
                  <span v-else-if="oi.ItemType == 'A1'"
                    ><van-tag size="large">{{ oi.ItemName }}</van-tag></span
                  >
                  <span v-else>{{ oi.ItemName }} </span>
                  <van-tag v-if="oi.Remark" size="large"> {{ oi.Remark }}</van-tag>
                  {{ oi.ItemType }}
                </van-col> -->

                <van-col span="2"
                  >x<span class="C1">{{ oi.Qty }}</span></van-col
                >
                <van-col span="5" align="right">
                  <span v-if="oi.Amt < 0" class="C4">{{ oi.Amt }}</span>
                  <span v-if="oi.Amt >= 0" class="C1">{{ oi.Amt }}</span
                  >元
                </van-col>
              </van-row>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <van-tabbar fixed placeholder>
        <FrmTableOrder
          :obj="obj"
          :custTotal="obj.CustTotal"
          @ok="visible = false"
          style="width: 100%"
        />
      </van-tabbar>
    </van-popup>
  </div>
</template>
<style scoped>
.s1 {
  font-weight: bold;
}
/* .s2 {
  color: #666;
} */
</style>

<script>
import FrmTableOrder from "./FrmTableOrder.vue";
// import Footer from "./Popup/Child/Footer.vue";
export default {
  components: { FrmTableOrder },
  data() {
    return {
      visible: false,
      title: "",
      obj: {},
      orderh: [],
      orderi: [],
      anime: true,
    };
  },
  methods: {
    isS1(obj) {
      if (obj.ItemType == "S2") {
        return false;
      }
      if (obj.ItemType == "A1") {
        return false;
      }
      return true;
    },
    async show(data) {
      this.obj = data;
      await this.init(this.obj.TblName);
      this.visible = true;
    },
    async init(pTblName) {
      try {
        this.gLoading();
        let query = { tblid: pTblName };
        let res = await this.apiGetOCheck(query);
        let data = res.data;
        this.orderh = data.orderh;
        this.orderi = data.orderi;

        console.log("data", data);
        // this.bkmenu = res.data;
        // console.log("bkmenu", this.bkmenu);
        // let extitem = this.bkmenu.extitem;
        // if (extitem[0]) this.items.push(extitem[0]);
        // if (extitem[1]) this.items.push(extitem[1]);
      } catch (error) {
        console.log(error.toString());
      } finally {
        this.gClearLoading();
      }
    },
    cmdClose() {
      this.orderh = [];
      this.orderi = [];
      this.visible = false;
    },

    async send(pTblName, pOrdertmp) {
      try {
        this.gLoading();
        for (let i = 0; i < pOrdertmp.length; i++) {
          console.log(i, pOrdertmp[i]);
          pOrdertmp[i].Groups.splice(0, 0, this.getTableTag("#" + i + 1));
        }
        let ordertmp = pOrdertmp.filter((r) => r.Qty > 0);
        console.log("ordertmp", ordertmp);
        var query = {
          tblname: pTblName,
          ordertmp: ordertmp,
        };

        this.gSure("確認傳送")
          .then(async () => {
            let res = await this.apiSendOrder(query);
            this.gMsgbox(res.data).then(() => {
              this.visible = false;
            });
          })
          .catch(() => {});
      } catch (error) {
        console.log(error);
        this.gMsgbox(error);
      } finally {
        this.gClearLoading();
      }
    },
  },
};
</script>
